import { useRequestHeaders } from '#app'
import { computed } from 'vue'

export function useDeviceType() {
  let userAgent = ''

  if (import.meta.server) {
    // 서버 사이드에서 요청 헤더의 User-Agent를 가져옵니다.
    const headers = useRequestHeaders(['user-agent'])
    userAgent = headers['user-agent'] || ''
  }
  else {
    // 클라이언트 사이드에서 navigator.userAgent를 사용합니다.
    userAgent = navigator.userAgent || ''
  }

  // 모바일 여부를 확인하는 computed 속성을 정의합니다.
  const isMobile = computed(() => {
    return /Mobi|Android|iPhone|iPad|iPod/i.test(userAgent)
  })

  return { isMobile }
}
